module.exports = __webpack_public_path__ + "img/wanglin.84538380.png";